import { datadogRum } from "@datadog/browser-rum";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { match } from "ts-pattern";
import LoadingOverlay from "@/components/atomic/LoadingOverlay";
import useAuth from "@/hooks/useAuth";
import useConfig from "@/hooks/useConfig";
import { showError } from "@/utils/notification";

const AuthProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation("common");
  const { isLoading: isLoadingConfig, error: configFetchError } = useConfig();

  // ユーザーの認証情報チェック
  const { isLoading: isLoadingUserInfo, error: userInfoFetchError, authUser } = useAuth();

  const isLoading = isLoadingConfig || isLoadingUserInfo;
  const hasError = !!configFetchError || !!userInfoFetchError;

  if (import.meta.env.VITE_ENABLE_DATADOG === "true" && authUser) {
    datadogRum.setUser({
      id: authUser.id,
      name: authUser.name,
      email: authUser.email,
    });
  }

  useEffect(() => {
    if (configFetchError || userInfoFetchError) {
      showError(t("auth.failedToFetchAuth"));
    }
  }, [configFetchError, userInfoFetchError, t]);

  return match({ isLoading, hasError })
    .with({ isLoading: true }, { hasError: true }, () => <LoadingOverlay />)
    .otherwise(() => <>{children}</>);
};

export default AuthProvider;
